import _classCallCheck from "/opt/build/repo/packages/ken-explorer/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/packages/ken-explorer/node_modules/@babel/runtime/helpers/esm/createClass";
var foo = "bar";
import * as gitNet from "./Interface.gen";
import * as R from "ramda";
export var Value =
/*#__PURE__*/
function () {
  function Value(value, fact, db) {
    _classCallCheck(this, Value);

    this.value = value;
    this.fact = fact;
    this.db = db;
    return this;
  }

  _createClass(Value, [{
    key: "json",
    value: function json() {
      return gitNet.Value_to_json(this.value);
    }
  }, {
    key: "dataType",
    value: function dataType() {
      return this.json().dataValue;
    }
  }, {
    key: "data",
    value: function data() {
      return this.json().data;
    }
  }, {
    key: "thing",
    value: function thing() {
      if (this.dataType() !== "thingId") {
        return false;
      }

      return this.db.findThing(this.data());
    }
  }]);

  return Value;
}();
export var FactList =
/*#__PURE__*/
function () {
  function FactList(db) {
    var factList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, FactList);

    this.db = db;
    this.factList = factList;
    return this;
  }

  _createClass(FactList, [{
    key: "filter",
    value: function filter(query) {
      if (this.factList.length == 0) {
        this.factList = gitNet.Graph_factList(this.db.graph);
      }

      var _query = gitNet.Query_from_json(query);

      var list = gitNet.Filter_query(_query, this.factList);
      return new FactList(this.db, list);
    }
  }, {
    key: "facts",
    value: function facts() {
      var _this = this;

      var ps = gitNet.list_to_array(this.factList);
      return ps.map(function (e) {
        return new Fact(e, _this.db);
      });
    }
  }]);

  return FactList;
}();
export var Fact =
/*#__PURE__*/
function () {
  function Fact(fact, db) {
    _classCallCheck(this, Fact);

    this.fact = fact;
    this.db = db;
    return this;
  }

  _createClass(Fact, [{
    key: "json",
    value: function json() {
      return gitNet.Fact_to_json(this.fact);
    }
  }, {
    key: "id",
    value: function id() {
      return this.json().id;
    }
  }, {
    key: "internalThing",
    value: function internalThing() {
      return this.db.findThing(this.id());
    }
  }, {
    key: "thing",
    value: function thing(edge) {
      var thing = gitNet.Graph_findThingFromFact(this.db.graph, edge, this.fact);
      return new Thing(thing, this.db);
    }
  }, {
    key: "property",
    value: function property() {
      return this.thing(gitNet.Graph_EdgeTypes_property);
    }
  }, {
    key: "subject",
    value: function subject() {
      return this.thing(gitNet.Graph_EdgeTypes_subject);
    }
  }, {
    key: "value",
    value: function value() {
      return new Value(gitNet.Fact_value(this.fact), this, this.db);
    }
  }]);

  return Fact;
}();
export var Thing =
/*#__PURE__*/
function () {
  function Thing(thing, db) {
    _classCallCheck(this, Thing);

    this.thing = thing;
    this.db = db;
    return this;
  }

  _createClass(Thing, [{
    key: "json",
    value: function json() {
      return gitNet.Thing_to_json(this.thing);
    }
  }, {
    key: "id",
    value: function id() {
      return this.json().id;
    }
  }, {
    key: "propertyIdFacts",
    value: function propertyIdFacts(id) {
      return this.isEdge("SUBJECT").filter({
        id: id,
        edge: "PROPERTY",
        q: ""
      }).facts();
    }
  }, {
    key: "isEdge",
    value: function isEdge(edge) {
      return new FactList(this.db).filter({
        id: this.json().id,
        edge: edge,
        q: ""
      });
    }
  }, {
    key: "isSubjectForFacts",
    value: function isSubjectForFacts() {
      return this.isEdge("SUBJECT").facts();
    }
  }, {
    key: "isPropertyForFacts",
    value: function isPropertyForFacts() {
      return this.isEdge("PROPERTY").facts();
    }
  }, {
    key: "isValueForFacts",
    value: function isValueForFacts() {
      return this.isEdge("VALUE").facts();
    }
  }, {
    key: "connectedPropertyThings",
    value: function connectedPropertyThings() {
      return this.isEdge("SUBJECT").facts().map(function (f) {
        return f.property();
      });
    }
  }, {
    key: "_byProperty",
    value: function _byProperty(edge) {
      var facts = this.isEdge(edge);
      var props = facts.facts().map(function (f) {
        return f.property();
      });
      var properties = R.uniqBy(function (r) {
        return r.id();
      }, props);
      var bunch = properties.map(function (property) {
        return {
          property: property,
          facts: facts.filter({
            id: property.json().id,
            edge: "PROPERTY",
            q: ""
          }).facts()
        };
      });
      return bunch;
    }
  }, {
    key: "isSubjectForFactsByProperty",
    value: function isSubjectForFactsByProperty() {
      return this._byProperty("SUBJECT");
    }
  }, {
    key: "isValueForFactsByProperty",
    value: function isValueForFactsByProperty() {
      return this._byProperty("VALUE");
    }
  }]);

  return Thing;
}();
export var Database =
/*#__PURE__*/
function () {
  function Database(data) {
    _classCallCheck(this, Database);

    this.graph = gitNet.Graph_fromJson(data);
    console.log("DB!", this.graph);
    return this;
  }

  _createClass(Database, [{
    key: "findThing",
    value: function findThing(id) {
      var thing = gitNet.Graph_findThing(id, this.graph);

      if (!!thing) {
        return new Thing(thing, this);
      } else {
        return false;
      }
    }
  }, {
    key: "directories",
    value: function directories() {
      return gitNet.Graph_directoryArray(this.graph);
    }
  }, {
    key: "childDirectories",
    value: function childDirectories(s) {
      return gitNet.Graph_childDirectories(this.graph, s);
    }
  }, {
    key: "rootDirectories",
    value: function rootDirectories() {
      return gitNet.Graph_rootDirectories(this.graph);
    }
  }, {
    key: "things",
    value: function things() {
      var _this2 = this;

      return gitNet.Graph_things(this.graph).filter(function (t) {
        return !!t;
      }).map(function (t) {
        return new Thing(t, _this2);
      });
    }
  }, {
    key: "json",
    value: function json() {
      return gitNet.Graph_to_json(this.graph);
    }
  }]);

  return Database;
}();
export function main(data) {
  return new Database(data);
}